import firebase from "firebase";

import "firebase/messaging";

var firebaseConfig = {
  apiKey: "AIzaSyAUNExAIL-saxkJKsSNgdwx6GPa9pOSqU8",
  authDomain: "urgidoctor-304509.firebaseapp.com",
  projectId: "urgidoctor-304509",
  storageBucket: "urgidoctor-304509.appspot.com",
  messagingSenderId: "237588825253",
  appId: "1:237588825253:web:a7de318dafce3f75f2b94c",
  measurementId: "G-SZSDPY8KL9",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let messaging;

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
}

export const getToken = setTokenFound => {
  return (
    messaging &&
    messaging
      .getToken({
        vapidKey:
          "BC4_i0P4o_9Z3vCePb6wgDhDkha6Wy6WpD4So1I7dfSIq5q-ChuEM9tBYO6njWxMTGeLLAW_L_1N-eu2BaAcXFo",
      })
      .then(currentToken => {
        if (currentToken) {
          setTokenFound(currentToken);
          return currentToken;
          // Track the token -> client mapping, by sending to backend server
          // show on the UI that permission is secured
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
          setTokenFound(undefined);
          return undefined;

          // shows on the UI that permission is required
        }
      })
      .catch(err => {
        console.log("An error occurred while retrieving token. ", err);
        // catch error while creating client token
      })
  );
};

export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    messaging
      ? messaging.onMessage(payload => {
          resolve(payload);
        })
      : reject("");
  });
